var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomplete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14C5.1862 14 2.5 11.3138 2.5 8C2.5 4.6862 5.1862 2 8.5 2C11.8138 2 14.5 4.6862 14.5 8C14.5 11.3138 11.8138 14 8.5 14ZM8.5 7.1516L6.8032 5.4542L5.9542 6.3032L7.6516 8L5.9542 9.6968L6.8032 10.5458L8.5 8.8484L10.1968 10.5458L11.0458 9.6968L9.3484 8L11.0458 6.3032L10.1968 5.4542L8.5 7.1516Z",
    fill: "#FF5865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomplete);
export default __webpack_public_path__ + "static/media/incomplete.f7d326ed19a025c9defd529ee97f57a6.svg";
export { ForwardRef as ReactComponent };